module.exports = __webpack_public_path__ + "static/media/urban_c.75142d76.tif";